import axios from 'axios'

// Public Sanity project coordinates — same project/dataset as the arcmosaico
// prototype. The read token is a Viewer token: article/hub documents use
// dotted _ids, which Sanity treats as private, so the anonymous API returns
// nothing without it. Kept as a constant in this first version (same approach
// as TEMP_n8nDirect), to be moved to a safer channel later.
const SANITY_PROJECT_ID = 'g2wkwya0'
const SANITY_DATASET = 'production'
const SANITY_API_VERSION = '2024-01-01'
const SANITY_READ_TOKEN =
  'skjMTWWp8bN8NAw6xPhb1PZrV56FXTDrCSlqP0Pvm0kkwTBlKsdY1ptfZ97H41WO9Pw23x9RRLcJIjApvyzaT09G7DTc0' +
  'h5ssZcgR1vTD5yOw4HoQDDTeAtggD7utrBdQohI7y14ucoZTnc7Bq3pZZKC0U1p4g8kgN3F7zfygg950NFhqzVl'

const SANITY_API_BASE = `https://${SANITY_PROJECT_ID}.api.sanity.io/v${SANITY_API_VERSION}`
const SANITY_QUERY_URL = `${SANITY_API_BASE}/data/query/${SANITY_DATASET}`
const SANITY_TIMEOUT_MS = 15000

export const SANITY_IMAGE_CDN_BASE = `https://cdn.sanity.io/images/${SANITY_PROJECT_ID}/${SANITY_DATASET}`

interface SanityQueryResponse<T> {
  result: T
}

// Dedicated axios instance: the legacy bootstrap writes the Rails
// X-CSRF-Token into the global axios defaults, which must never leak to
// api.sanity.io. axios.create() copies those defaults at create time, so the
// inherited common headers are cleared explicitly.
const sanityAxios = axios.create()
sanityAxios.defaults.headers.common = {}

// Runs a GROQ query against the Sanity HTTP API. perspective=published keeps
// drafts out even with the authenticated token, mirroring the prototype.
export const fetchSanityQuery = async <T>(query: string, params: Record<string, string> = {}): Promise<T> => {
  const searchParams: Record<string, string> = { query, perspective: 'published' }
  Object.entries(params).forEach(([key, value]) => {
    // The HTTP API expects GROQ params as `$name` keys with JSON-encoded values.
    searchParams[`$${key}`] = JSON.stringify(value)
  })

  const response = await sanityAxios.get<SanityQueryResponse<T>>(SANITY_QUERY_URL, {
    params: searchParams,
    headers: { Authorization: `Bearer ${SANITY_READ_TOKEN}` },
    timeout: SANITY_TIMEOUT_MS,
  })

  return response.data.result
}
